import { CameraIcon, IdUserIcon } from '@approvalmax/ui';
import { Box, Grid, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { messages } from './Help.messages';

export const Help = memo(() => {
    return (
        <Box color='white100' radius='small' spacing='24'>
            <Grid gap={12}>
                <Grid gap={4}>
                    <Text font='label' fontSize='medium' fontWeight='medium'>
                        {messages.whatsRequired}
                    </Text>

                    <Text font='body' fontSize='small'>
                        {messages.verification}
                    </Text>
                </Grid>

                <Grid gridTemplateColumns='max-content auto' gap={8}>
                    <IdUserIcon size={16} />

                    <Text font='body' fontSize='small'>
                        {messages.originalDocument}
                    </Text>
                </Grid>

                <Grid gridTemplateColumns='max-content auto' gap={8}>
                    <CameraIcon size={16} />

                    <Text font='body' fontSize='small'>
                        {messages.camera}
                    </Text>
                </Grid>
            </Grid>
        </Box>
    );
});

Help.displayName = 'Help';
